import React from 'react';
import { useTranslation } from '../../context/LanguageContext';
import Sidebar from './Sidebar';

const Layout = ({ children }) => {
    const { isRTL } = useTranslation();

    return (
        <div className="flex min-h-screen bg-gray-100">
            <div className={`fixed inset-y-0 ${isRTL ? 'right-0' : 'left-0'} w-64 transition-transform duration-300 ease-in-out`}>
                <Sidebar />
            </div>
            <main className={`flex-1 ${isRTL ? 'mr-64' : 'ml-64'} p-8 transition-all duration-300 ease-in-out`}>
                <div className={isRTL ? 'text-right' : 'text-left'}>
                    {children}
                </div>
            </main>
        </div>
    );
};

export default Layout;
